"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_options_general_1 = require("owa-options-general");
var owa_options_mail_1 = require("owa-options-mail");
var owa_options_calendar_1 = require("owa-options-calendar");
require("owa-options-mail"); // Imported to bootstrap several services
var mobx_1 = require("mobx");
var UNFILTERED_OPTIONS = [owa_options_general_1.GeneralOptions, owa_options_mail_1.MailOptions, owa_options_calendar_1.CalendarOptions];
var collectedOptions = mobx_1.computed(function () {
    return UNFILTERED_OPTIONS.map(function (category) {
        category = tslib_1.__assign({}, category, { subcategories: category.subcategories
                .map(function (subcategory) {
                subcategory = tslib_1.__assign({}, subcategory, { options: subcategory.options.filter(function (option) { return !option.isHidden || !option.isHidden(); }) });
                return subcategory;
            })
                .filter(function (subcategory) { return subcategory.options.length > 0; }) });
        return category;
    }).filter(function (category) { return category.subcategories.length > 0; });
});
exports.default = function () { return collectedOptions.get(); };
//# sourceMappingURL=collectedOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-options-store/lib/config/collectedOptions.js
// module id = 3173
// module chunks = 2